import { render, staticRenderFns } from "./ClaimItemType.vue?vue&type=template&id=5fd23282&"
import script from "./ClaimItemType.vue?vue&type=script&lang=js&"
export * from "./ClaimItemType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fd23282')) {
      api.createRecord('5fd23282', component.options)
    } else {
      api.reload('5fd23282', component.options)
    }
    module.hot.accept("./ClaimItemType.vue?vue&type=template&id=5fd23282&", function () {
      api.rerender('5fd23282', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Claim/ClaimItemType/ClaimItemType.vue"
export default component.exports